import { Footer } from '@/previewThemes/minimal/Footer';
import { Header } from '@/previewThemes/minimal/Header';
import { Product } from '@/previewThemes/minimal/Product';
import type { ThemePackage } from '@/previewThemes/types';

export const theme: ThemePackage = {
  Header,
  Footer,
  Product,
  listing: {
    grid: 'grid-cols-2 gap-8 lg:grid-cols-4',
    filters: 'inline',
    columns: 4,
    card: 'airy',
  },
  // Nothing boxed anywhere. This theme's whole argument is that a border is
  // one more thing on the page.
  cart: { grid: 'mt-10 grid gap-12 lg:grid-cols-3', panel: 'bare' },
  checkout: {
    grid: 'mt-10 grid items-start gap-12 lg:grid-cols-[minmax(0,1fr)_20rem]',
    panel: 'bare',
  },
  search: {
    grid: 'mt-10 grid gap-12 lg:grid-cols-[200px_1fr]',
    results: 'grid grid-cols-2 gap-8 lg:grid-cols-4',
    columns: 4,
    card: 'airy',
  },
  blog: { list: 'grid max-w-2xl gap-10', title: 'text-xl' },
  category: { grid: 'grid gap-8 sm:grid-cols-2 lg:grid-cols-4', tile: 'bare' },
  // What this theme used to write on `BuyBox` and `ProductGallery` by hand.
  // The merchant's components read it wherever they have left a setting at
  // "the theme's own", which is where every shop starts - so a shop nobody
  // has arranged renders the product page this theme has always drawn.
  parts: {
    product_details: {
      presentation: {
        classes: { product_title: 'text-2xl' },
        wideButtons: true,
      },
    },
  },
};
